<template>
  <v-theme-provider :dark="dark">
    <div>
      <!-- <base-info-card :title="title" color="primary">
        <slot />
      </base-info-card> -->
      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="3"
        >
          <div v-html="text" />
        </base-avatar-card>
      </template>
      <v-btn
        color="blue"
        href="https://www.facebook.com/myeduvisa.srilanka"
        target="_blank"
        icon
        x-large
      >
        <v-icon color="blue darken-4" size="30" class="px-1">
          mdi-facebook
        </v-icon>
      </v-btn>
      <v-btn
        color="blue lighten-2"
        href="https://www.linkedin.com/company/kenwyn-consultancy-services-pvt-ltd"
        target="_blank"
        icon
        x-large
      >
        <v-icon color="blue lighten-1" size="30" class="px-1">
          mdi-linkedin
        </v-icon></v-btn
      >
      <v-btn
        color="green darken-2"
        href="https://api.whatsapp.com/send?phone=94262055830"
        target="_blank"
        icon
        x-large
        ><v-icon color="green" size="30" class="px-1">
          mdi-whatsapp</v-icon
        ></v-btn
      >
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessContact",

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String,
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "Kenwyn Consultancy Services PVT.  Ltd . <br> No 20, <br> 2nd Lane Linganagar,<br> Trincomalee",
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+94-26 205 5830",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@myeduvisa.com",
      },
    ],
  }),
};
</script>
